export const centsToDollarDisplay = (
  value: number | undefined,
  showDollarSign: boolean,
  hideDecimalsIfNoCents: boolean
): string => {
  if (value === undefined) return '';
  let display: string | number = value / 100;
  if (value % 100 !== 0 || (value % 100 === 0 && !hideDecimalsIfNoCents)) {
    display = (value / 100).toFixed(2);
  }
  return showDollarSign ? `$${display}` : `${display}`;
};
